import React, { useEffect, useState } from "react";
import { SmartLink } from "./SiteHeader";

const API = process.env.REACT_APP_BACKEND_URL;

export function useHotTakeFor(page) {
  const [post, setPost] = useState(null);
  useEffect(() => {
    if (!page) return;
    fetch(`${API}/api/public/vault/hot-take-for/${page}`).then((r) => (r.ok ? r.json() : null)).then((d) => setPost(d?.item || null)).catch(() => {});
  }, [page]);
  return post;
}

export function HotTakeRailCard({ page }) {
  const post = useHotTakeFor(page);
  if (!post) return null;
  return (
    <SmartLink className="rail-card rail-calc rail-hottake" href={`/strategy-vault/${post.slug}/`} data-testid="solution-rail-hot-take">
      <img src={post.hero_image} alt="" loading="lazy" />
      <div>
        <span className="tag"><img className="rail-hottake-chili" src="/brand/vault/icons/chili.png" alt="" aria-hidden="true" />Matt’s Hot Take · On exactly this</span>
        <h3>{post.title}</h3>
        <p>{post.opening?.[0] || post.summary}</p>
        <span className="tool-link">Read the hot take →</span>
      </div>
    </SmartLink>
  );
}

export function HotTakeBand({ page, tag, testId, flush = false }) {
  const post = useHotTakeFor(page);
  if (!post) return null;
  return (
    <section className={`xp-hottake-sec${flush ? " flush" : ""}`} data-testid={`${testId}-section`}>
      <div className="wrap">
        <SmartLink href={`/strategy-vault/${post.slug}/`} className="xp-hottake" data-testid={testId}>
          <img src={post.hero_image} alt="" loading="lazy" />
          <div>
            <span className="tag"><img className="rail-hottake-chili" src="/brand/vault/icons/chili.png" alt="" aria-hidden="true" />{tag}</span>
            <h3>{post.title}</h3>
            <p>{post.opening?.slice(0, 4).join(" ") || post.summary}</p>
            <span className="tool-link">Read the hot take →</span>
          </div>
        </SmartLink>
      </div>
    </section>
  );
}
